import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'src/components/tooltip';
import Stamp, {GREEN} from 'src/components/Stamp/Stamp';
import Icon from 'shared/components/icon';

const propTypes = {
  deadlineDay: PropTypes.number,
  deadlineMonth: PropTypes.number,
  showTooltipFlag: PropTypes.bool,
  useApplyByTerminology: PropTypes.bool,
};

const SubmittedText = ({
  deadlineDay,
  deadlineMonth,
  showTooltipFlag = false,
  useApplyByTerminology,
}) => {
  const infoText = `Submitted! ${
    useApplyByTerminology ? 'Apply' : 'Be admitted'
  } by ${deadlineMonth}/${deadlineDay}`;
  if (!showTooltipFlag) {
    return (
      <Stamp color={GREEN}>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp className="check" color={GREEN}>
            <Icon iconType="check" color="green" className="tooltip-check-icon" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

SubmittedText.propTypes = propTypes;

export default SubmittedText;
